import { render, staticRenderFns } from "./BillOfLoadProblems.vue?vue&type=template&id=4dd390ce&scoped=true"
import script from "./BillOfLoadProblems.vue?vue&type=script&lang=js"
export * from "./BillOfLoadProblems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd390ce",
  null
  
)

export default component.exports